import { get } from './api';

const DASHBOARD_STATS_URL = '/dashboard/stats';

const buildQueryParams = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.from_date) queryParams.append('from_date', params.from_date);
  if (params.to_date) queryParams.append('to_date', params.to_date);
  if (params.branch_id) queryParams.append('branch_id', params.branch_id);
  if (params.status) queryParams.append('status', params.status); // "order_placed,completed"
  if (params.filter) queryParams.append('filter', params.filter); // "month" or "week"
  if (params.order_type) queryParams.append('order_type', params.order_type); // "invoice" or "quotation"

  return queryParams.toString();
};

export const getDashboardStats = (params = {}) => {
  const queryString = buildQueryParams(params);
  const url = `${DASHBOARD_STATS_URL}${queryString ? `?${queryString}` : ''}`;
  return get(url);
};

export const getSidebarCounts = () => {
  return get('/dashboard/sidebar-counts');
};

export const getDashboardBranch = (branchId, params = {}) => {
  const fullParams = {
    ...params,
    branch_id: branchId === "all" ? undefined : branchId,
  };

  const queryString = buildQueryParams(fullParams);
  const url = `${DASHBOARD_STATS_URL}${queryString ? `?${queryString}` : ''}`;
  return get(url);
};